export const fieldHelper = ((object) => {

  let csv = Object.keys(object).find(key => object[key].type === 'csv');
  if(csv && object[csv].value){
    object[csv]['value']['label'] = object[csv]['label'];
  }
  if(csv && !object[csv].value){
    object[csv]['label'] = 'Covariates';
    object[csv]['value'] = {};
    object[csv]['value']['type'] = "csv";
    object[csv]['value']['items'] = "['boolean','number','string']";
    object[csv]['value']['source'] = "member";
    object[csv]['value']['order'] = csv;
    object[csv]['value']['label'] = 'Covariates';
  }

  let freesurfer = Object.keys(object).find(key => object[key].type === 'freesurfer');
  if(freesurfer && object[freesurfer].value){
    object[freesurfer]['value']['label'] = object[freesurfer]['label'];
  }
  if(freesurfer && !object[freesurfer].value){
    object[freesurfer]['label'] = 'Data';
    object[freesurfer]['value'] = {};
    object[freesurfer]['value']['type'] = "freesurfer";
    object[freesurfer]['value']['items'] = "['FreeSurfer']";
    object[freesurfer]['value']['extensions'] = "['csv','txt']";
    object[freesurfer]['value']['source'] = "owner";
    object[freesurfer]['value']['order'] = freesurfer;
    object[freesurfer]['value']['label'] = 'Data';
  }

  let files = Object.keys(object).find(key => object[key].type === 'files');
  if(files && object[files].value){
    object[files]['value']['label'] = object[files]['label'];
  }
  if(files && !object[files].value){
    object[files]['label'] = 'Data';
    object[files]['value'] = {};
    object[files]['value']['type'] = "files";
    object[files]['value']['items'] = "['Files']";
    object[files]['value']['items'] = "['csv','txt','gz','nii']";
    object[files]['value']['source'] = "member";
    object[files]['value']['order'] = files;
    object[files]['value']['label'] = 'Data';
  }

  let directory = Object.keys(object).find(key => object[key].type === 'directory');
  if(directory && object[directory].value){
    object[directory]['value']['label'] = object[directory]['label'];
  }
  if(directory && !object[directory].value){
    object[directory]['label'] = 'Data';
    object[directory]['value'] = {};
    object[directory]['value']['type'] = "directory";
    object[directory]['value']['items'] = "['Files (In Directory)']";
    object[directory]['value']['source'] = "member";
    object[directory]['value']['order'] = directory;
    object[directory]['value']['label'] = 'Data';
  }

  let boolean = Object.keys(object).find(key => object[key].field === 'boolean');
  if(boolean && object[boolean].value){
    object[boolean]['value']['label'] = object[boolean]['label'];
  }
  if(boolean && !object[boolean].value){
    object[boolean]['label'] = 'Boolean';
    object[boolean]['owner'] = true;
    object[boolean]['value'] = {};
    object[boolean]['value']['type'] = 'boolean';
    object[boolean]['value']['default'] = false;
    object[boolean]['value']['source'] = 'owner';
    object[boolean]['value']['order'] = boolean;
  }

  let string = Object.keys(object).find(key => object[key].field === 'string');
  if(string && object[string].value){
    object[string]['value']['label'] = object[string]['label'];
  }
  if(string && !object[string].value){
    object[string]['label'] = 'String';
    object[string]['owner'] = true;
    object[string]['value'] = {};
    object[string]['value']['type'] = 'string';
    object[string]['value']['default'] = '';
    object[string]['value']['source'] = 'owner';
    object[string]['value']['order'] = string;
  }

  let number = Object.keys(object).find(key => object[key].field === 'number');
  if(number && object[number].value){
    object[number]['value']['label'] = object[number]['label'];
  }
  if(number && !object[number].value){
    object[number]['label'] = 'number';
    object[number]['owner'] = true;
    object[number]['value'] = {};
    object[number]['value']['type'] = 'number';
    object[number]['value']['default'] = 0;
    object[number]['value']['source'] = 'owner';
    object[number]['value']['order'] = number;
  }

  let range = Object.keys(object).find(key => object[key].field === 'range');
  if(range && object[range].value){
    object[range]['value']['label'] = object[range]['label'];
  }
  if(range && !object[range].value){
    object[range]['label'] = 'range';
    object[range]['owner'] = true;
    object[range]['value'] = {};
    object[range]['value']['type'] = 'range';
    object[range]['value']['default'] = 0;
    object[range]['value']['min'] = 0;
    object[range]['value']['max'] = 25;
    object[range]['value']['step'] = 5;
    object[range]['value']['source'] = 'owner';
    object[range]['value']['order'] = range;
  }

  let obj = Object.keys(object).find(key => object[key].field === 'object');
  if(obj && object[obj].value){
    object[obj]['value']['label'] = object[obj]['label'];
  }
  if(obj && !object[obj].value){
    object[obj]['label'] = 'object';
    object[obj]['owner'] = true;
    object[obj]['value'] = {};
    object[obj]['value']['type'] = 'object';
    object[obj]['value']['default'] = '{key: value}';
    object[obj]['value']['source'] = 'owner';
    object[obj]['value']['order'] = obj;
  }

  let sel = Object.keys(object).find(key => object[key].field === 'select');
  if(sel && object[sel].value){
    object[sel]['value']['label'] = object[sel]['label'];
  }
  if(sel && !object[sel].value){
    object[sel]['label'] = 'select';
    object[sel]['owner'] = true;
    object[sel]['value'] = {};
    object[sel]['value']['type'] = 'select';
    object[sel]['value']['default'] = "['val1','val2','val3']";
    object[sel]['value']['source'] = 'owner';
    object[sel]['value']['order'] = obj;
  }

  return object;
});

export const beautifyJSON = ((jsObj) => {
  if(typeof jsObj === 'object'){
		jsObj = JSON.stringify(jsObj, null, "\t"); // stringify with tabs inserted at each level
		jsObj = JSON.stringify(jsObj, null, 2);    // stringify with 4 spaces at each level
		return JSON.parse(jsObj);
	}else{
	  jsObj = JSON.parse(jsObj);
		jsObj = JSON.stringify(jsObj, null, "\t"); // stringify with tabs inserted at each level
		jsObj = JSON.stringify(jsObj, null, 2);    // stringify with 4 spaces at each level
		return JSON.parse(jsObj);
	}
});

export const parseInputs = (data) => {
  let obj = {};
  Object.keys(data).map((key, index) => {
    //Handle Covariate Data Type
    console.log(data[key]['data']);
    if(data[key]['type'] === 'csv' && !data[key]['data']){
      obj[key] = {
        "value": {
          "file1.ext":{
            "cov1": "value",
            "cov2":  "value",
            "cov3":  "value"
          },
          "file2.ext":{
            "cov1": "value",
            "cov2":  "value",
            "cov3":  "value"
          }
        }
      }
    }else if(data[key]['type'] === 'csv' && data[key]['data']){
      let newData = data[key]['data'];
      obj[key] = {
        "value": JSON.parse(JSON.stringify(newData).replaceAll('\"','').replaceAll('\\','').replaceAll('"',''))
      }
    }
    //Handle Freesurfer/NiFTI Data Type
    if(data[key]['type'] === 'freesurfer'){
      let type = data[key]['items'];
      type = JSON.parse(type.replaceAll('\'','"'));
      obj[key] = {
        "fulfilled": true,
        "value": [
          {
            "type": type[0],
            "value":  ["5th-Ventricle"]
          }
        ]
      }
    }
    //Handle Files Data Type
    if(data[key]['type'] === 'files'){
      obj[key] = {
        "fulfilled": true,
        "value": [
          "file1.ext",
          "file2.ext",
          "file3.ext",
          "file4.ext",
          "file5.ext",
        ]
      }
    }
    //Handle Directory Data Type
    if(data[key]['type'] === 'directory'){
      obj[key] = {
        "fulfilled": true,
        "value": "/path/to/local/directory"
      }
    }
    if(
        data[key]['type'] !== 'csv' &&
        data[key]['type'] !== 'freesurfer' &&
        data[key]['type'] !== 'files' &&
        data[key]['type'] !== 'directory'
      ){
      obj[key] = {
        "fulfilled": true,
        "value": data[key]['default']
      }
    }
  });
  return obj;
}

export const parseCompspec = ((basics, selects) => {
	let newobj = {};
  selects.map((item) => {
	  if(item.label){
      let key = item.label.toLowerCase().replaceAll(' ','_');
      newobj[key] = item.value;
		}
	});
  basics['computation']['input'] = newobj;
  return beautifyJSON(basics);
});

export const parseInputspec = ((compspec) => {
  compspec = JSON.parse(compspec);
  let input = compspec['computation']['input'];
  let inputs = parseInputs(input);
  return beautifyJSON(inputs);
});
